import { Decimal } from 'decimal.js';

/**
 * 字符串重复生成
 * @param str
 * @param n
 * @returns {string}
 */
const repeater = function (str, n) {
    return Array(n).fill(str).join('');
};

/**
 * 数字保留固定位数字符串
 * @param number
 * @param fractional
 * @returns {string}
 */
export const numberToFixedString = function (number, fractional) {
    const x = new Decimal(number);
    return x.toFixed(fractional);
};

/**
 * 判断字符串是否为数字类型
 * @param str
 * @returns {boolean}
 */
export const isNumeric = function (str) {
    return !isNaN(parseFloat(str)) && isFinite(str);
};

/**
 * 数字保留固定位数小数（采用 toFixed 方法）
 * @param {*} number
 * @param {*} fractional
 */
export const numberToFixed = function (number, fractional) {
    return parseFloat(parseFloat(number).toFixed(fractional));
};

/**
 * 数字转千分位字符串
 * @param {*} num 数字
 * @param {*} fractional 小数位数
 * @param {*} currencyPrefix 货币前缀
 */
export const number2ThousandsFormat = function (num, fractional, currencyPrefix) {
    // 判断是否有小数点
    if (num === null) {
        return '';
    }
    let s = num.toString().indexOf('.');
    if (s === -1) { // 是整数
        return currencyPrefix + (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + repeater('0', fractional);
    }
    else { // 是小数
        let arr = num.toString().split('.');
        if (arr.length > 1 && arr[1].length < fractional) {
            return currencyPrefix + (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + arr[1] + '0';
        }
        else {
            return currencyPrefix + (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + arr[1].substr(0, fractional);
        }
    }
};

/**
 * 千分位字符串转数字
 * @param {*} str 字符串
 * @param {*} currencyPrefix 货币前缀
 */
export const thousandsFormat2Number = function (str, currencyPrefix) {
    str += '';
    str = str.replace(/[,]/g, '').replace(currencyPrefix, '');
    if (isNumeric(str)) {
        return parseFloat(str);
    }
    return NaN;
};

/**
 * 数字转百分比格式
 * @param {*} num 值域从[0-100]的数字
 */
export const number2PercentFormat = function (num) {
    return num + '%';
};

/**
 * 百分比格式转数字，返回[0-100]的数字
 * @param {*} str
 */
export const percentFormat2Number = function (str) {
    str = str.replace('%', '');
    if (isNumeric(str)) {
        return parseFloat(str);
    }
    return NaN;
};


//千分位显示
export const getNumberThousandString=function (num, delfaultValue='', dig=2){
    if(num){
        let numTwoDigit =num.toFixed(2);
        return parseFloat(numTwoDigit).toLocaleString("en", { minimumFractionDigits: dig });
    }
    else{
     
        return delfaultValue;
    }
};

//转换成小数位数向下取整，dig小数位数
export const getNumberFloorDecimal=function (num, dig=2){
    if(!num){
        return 0.00;
    }
    // console.log(num);
    // num=Number(num);
    // let num1=num.toFixed(2)
    // console.log(num1)
    // return num1;
    let decimalNumber = new Decimal(num);
    // 保留两位小数并向下取整
    return decimalNumber.toDecimalPlaces(dig, Decimal.ROUND_FLOOR).toNumber();
};

//减法运算
export const numberSubtraction=function (num1, num2){
    if(!num1||isNaN(num1)){
        num1=0;
    }
    if(!num2||isNaN(num2)){
        num2=0;
    }
    num1=new Decimal(num1);
    num2=new Decimal(num2);
    // 保留两位小数并向下取整
    return num1.sub(num2).toNumber();
};

//decimal四舍五入后转化位千分位字符串
export const formatWithDecimalFixed=function (num, dig) {
    // 设置小数点后需要保留的位数
// Decimal.set({ precision: dig });
 
// 创建一个Decimal实例
    let number = new Decimal(num);
 
    // 使用toFixed方法四舍五入到指定的小数位数
    let roundedNumber = number.toFixed(dig); 

    return formatWithCommas(roundedNumber);
};


// 千分位格式化函数
export const formatWithCommas=function (value) {
    let parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
};

/**
 * 数字转中文金额大写
 * @param {number} n
 * @returns {string}
 */
export const smalltoBIG = function (n) {
    const fraction = ["角", "分"];
    const digit = [
        "零",
        "壹",
        "贰",
        "叁",
        "肆",
        "伍",
        "陆",
        "柒",
        "捌",
        "玖"
    ];
    const unit = [
        ["元", "万", "亿"],
        ["", "拾", "佰", "仟"]
    ];
    const head = n < 0 ? "欠" : "";
    n = Math.abs(n);

    let s = "";
    for (let i = 0; i < fraction.length; i++) {
        s += (
            digit[Math.floor(n * 10 * Math.pow(10, i)) % 10]
            + fraction[i]
        ).replace(/零./, "");
    }
    s = s || "整";
    n = Math.floor(n);

    for (let i = 0; i < unit[0].length && n > 0; i++) {
        let p = "";
        for (let j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s
            = p.replace(/(零.)*零$/, "").replace(/^$/, "零")
            + unit[0][i]
            + s;
    }
    return (
        head
        + s
            .replace(/(零.)*零元/, "元")
            .replace(/(零.)+/g, "零")
            .replace(/^整$/, "零元整")
    );
};

